import type { FaireProductEntity } from "../../entity_types/product";

export const p_ab4naszqqc: FaireProductEntity = {
  token: "p_ab4naszqqc",
  type: "product",
  name: "Cocoa Cashmere Soy Candle - 4oz Travel Tin & Wood Wick",
  brandToken: "b_4643yu7ag8",
  brandName: "Mad Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/0c2aad6bcaa562144c2a44894008e6b63f93adb29dcb7986419263caa9e31420.jpeg",
  galleryImageUrls: [],
  priceDollars: 8,
  description:
    'raw cocoa butter • night-blooming jasmine • blonde cedarwood\n\nPRODUCT INFORMATION:\nOur 4 oz Gold Metal Travel Tin candles are hand-poured in Eugene, Oregon, featuring sleek gold tins with a polished finish and a matching gold metal lid. These compact, handmade candles offer a generous 15-20 hour burn time, perfect for on-the-go use. Dimensions: 3.25" W x 1.25" H. Ideal for retail displays, gift shops, and travel enthusiasts.\n\nThe entire Mad Candle Co. collection is made with only the best ingredients in the industry including 100% domestically-grown soy wax, clean fragrance oils, and sustainable FSC-certified wood wicks. The fragrances we use are vegan, paraben-free, and phthalate-free.',
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:02.314Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
